const PERFIS_FINANCEIRO = ['admin', 'diretor', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'];

// Rafael (28/09): "O evento que renegocia com os fornecedores, Financeiro apenas registra se
// chegou ou não." Renegociar e Editar valor/vencimento = equipe do evento (+ admin/diretor).
// O Financeiro só informa o crédito (Creditado / Não creditado) em Contas a Receber.
// Espelho na API: App\Services\Financeiro\AdiantamentoRenegociacaoPolicy.
export const PERFIS_RENEGOCIAR_ADIANTAMENTO = ['admin', 'diretor', 'evento', 'gerenteevento', 'gerenteeventointernacional'];

export const MENSAGEM_SEM_PERMISSAO_RENEGOCIAR = 'A renegociação é feita pela equipe do evento (Eventos, Gerente de Eventos). O Financeiro apenas informa se o crédito caiu.';

export const podeRenegociarAdiantamento = (perfil) =>
    PERFIS_RENEGOCIAR_ADIANTAMENTO.includes(String(perfil || '').trim().toLowerCase());

/** Criação normal do pedido; no modo renegociar vale a regra da equipe do evento. Não libera aprovação ou pagamento. */
export const podeRegistrarSolicitacaoAdiantamento = (perfil, modoRenegociar = false) => {
    if (modoRenegociar) {
        return podeRenegociarAdiantamento(perfil);
    }

    return [...PERFIS_FINANCEIRO, 'evento'].includes(String(perfil || '').toLowerCase());
};
